import React from "react";
import App from "./App";
import ReactDOM from "react-dom";
import { overwrite } from "country-list";
import axios from "axios";
import "./style.css";

overwrite([
  {
    code: "GB",
    name: "United Kingdom",
  },
]);

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_PATH || "";

window.onload = function () {
  ReactDOM.render(<App />, document.getElementById("root"));
};
